var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"effect":_vm.isDark ? 'dark':'light',"content":_vm.content,"placement":"top-start"}},[_c('span',[_vm._t("default"),_vm._v(" "),_c('i',{staticClass:"el-icon-question",staticStyle:{"cursor":"pointer"}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }